<template>
  <div class="brands-container">
    <div class="brands">
      <div class="separator" v-bind:class="{ 'separator-white': isWhite }"></div>
      <a class="link" v-bind:class="{ 'link-white': isWhite }" href="https://louren.jp/" target="_blank">louren</a>
      <div class="separator" v-bind:class="{ 'separator-white': isWhite }"></div>
    </div>
    <div class="brands">
      <div class="separator isHide" v-bind:class="{ 'separator-white': isWhite }"></div>
      <a class="link" v-bind:class="{ 'link-white': isWhite }" href="https://hella-design.com" target="_blank">Hella</a>
      <div class="separator" v-bind:class="{ 'separator-white': isWhite }"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Brands',
  props: {
    isWhite: Boolean
  }
}
</script>

<style scoped>
.brands-container {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  padding: 0 0 32px 48px;
}
.brands {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
}
.link {
  font-size: 12px;
  padding: 0 22px;
  letter-spacing: 3.6px;
  color: #000;
}
.link-white {
  color: #fff;
}
.link-white:visited {
  color: #fff;
}
.link-white:active {
  color: #fff;
}
.link-black {
  color: #000;
}
.link-black:visited {
  color: #000;
}
.link-black:active {
  color: #000;
}
.separator {
  margin: 4px 0;
  border-left: solid 1px #000;
}
.separator-white {
  border-left: solid 1px #fff;
}
.separator-black {
  border-left: solid 1px #000;
}
.isHide {
  display: none;
}
@media (max-width: 639px) {
  .brands-container {
    padding: 0 24px 16px 24px;
  }
  .link {
    font-size: 14px;
    padding: 0 12px;
    letter-spacing: 3.5px;
  }
  .isHide{
    display: none;
  }
}
/* 2行にするブレイクポイント */
@media (max-width: 390px) {
  .brands {
    width: 100%;
    justify-content: center;
  }
  .link {
    flex: 1;
    text-align: center;
  }
  .isHide{
    display: inline;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modules/Brands.vue